'use client';

import { ArrowRightIcon } from '@radix-ui/react-icons';
import { Box, Card, Flex, Text } from '@radix-ui/themes';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface Props {
  topicName: string;
}

const NeedHelp = ({ topicName }: Props) => {
  const path = usePathname();
  return (
    <Card asChild>
      <Link
        href={`${path}/reference`}
        passHref
      >
        <Text
          as='div'
          size='2'
          weight='bold'
        >
          Нужна помощь?
        </Text>
        <Flex align='center'>
          <Box width={{ initial: '100%', sm: '250px' }}>
            <Text
              as='div'
              color='gray'
              size='2'
            >
              Cправочный материал по теме «{topicName}»
            </Text>
          </Box>
          <ArrowRightIcon />
        </Flex>
      </Link>
    </Card>
  );
};

export default NeedHelp;
